export function initComparisonPlugin() {
    // Check rapido se esiste il componente nel DOM
    const hasComparison = document.querySelector('.js-comparison-container');

    if (hasComparison) {
        // Import dinamico del modulo JS pesante
        import('./comparison_plugin.js')
            .then(module => {
                module.default();
            })
            .catch(err => console.error('Error loading Comparison Plugin:', err));
    }
}
